import React, { useState, useEffect } from 'react';
import ApiService from '../../../services/apiService';
import { toast } from 'react-toastify';
import moment from 'moment';

const ItemGridGRN = ({ onRequisitionData, itemData, grnData, selectedPOData, currencyPrecision }) => {
    const [rows, setRows] = useState([{
        requisitionNo: '',
        srno: '',
        recordId: '',
        ItemNo: '',
        itemDescription: '',
        specification: '',
        qty: '',
        uom: '',
        baseQty: '',
        baseAmount: '',
        amount: '',
        discount: '',
        vat: '',
        vatDes: '',
        vatAmount: '',
        balQty: "",
        freeQty: "",
        convValue: '',
        discount: '',
        discountAmount: '',
        calculatedAmount: "",
        expDate: null,
        batchNo: "",
        inventoryAccountCode: "",
        inventoryAccountName: "",
    }]);
    useEffect(() => {
        const getItems = async () => {
            try {
                const apiService = new ApiService();
                const formattedRowsitm = itemData.map(async (detail, index) => {
                    const selecteditms = await apiService.getApiParamater("GET_ITEM", `?ItemNo=${detail.itemCode}`);
                    const getGLAccounts = await apiService.getApiParamater("GET_ITEM_GL", `?ItemNo=${detail.itemCode}`);
                    let glAccount = getGLAccounts?.data?.result[0] || ""
                    let itm = selecteditms?.data?.result[0]

                    return {
                        requisitionNo: detail?.requisitionNo,
                        srno: detail?.srno,
                        ItemNo: detail?.itemCode,
                        itemDescription: detail?.itemDescription,
                        uom: detail?.uom,
                        baseQty: 0,
                        qty: 0,
                        freeQty: detail?.extraQty || 0,
                        convValue: itm?.convToInvUOM || 0,
                        baseAmount: detail?.unitPrice?.toFixed(currencyPrecision || 0),
                        vatDes: detail?.vatDesc,
                        vat: detail?.vatPerc || 0,
                        vatAmount: 0,
                        specification: detail ? detail?.specification : '',
                        amount: 0,
                        balQty: detail?.balQty || 0,
                        inventoryAccountCode: glAccount?.inventoryAccountCode || "",
                        inventoryAccountName: glAccount?.inventoryAccountName || "",
                        GRNAccountName: glAccount?.grnAccountName || "",
                        GRNAccountCode: glAccount?.grnAccountCode || "",
                    };
                }).filter(row => row !== null);
                const formattedRows = await Promise.all(formattedRowsitm);
                if (formattedRows.length > 0) {
                    setRows(formattedRows);
                    onRequisitionData(formattedRows);
                }
            } catch (error) {

                console.error('Error fetching items:', error);
            }
        };

        if (itemData.length > 0) {
            getItems();
        }
    }, [itemData]);
    const handleQtyChange = (index, value) => {
        const newQty = value;
        const balQty = rows[index].balQty;
        const freeQty = rows[index].freeQty || 0;
        const unitPrice = rows[index].baseAmount;
        const vatPerc = rows[index].vat;
        const vatDes = rows[index].vatDes;
        const vatInclusive = rows[index].costCenter5;
        const UOM = rows[index].convValue;

        if (newQty < 0) {
            toast.warning('Quantity cannot be less than 0.');
            return;
        }
        if (newQty > balQty) {
            toast.warning('Enter a quantity less than or equal to the balance quantity.');
            return;
        }

        const amountBeforeVat = newQty * unitPrice;
        const vatAmount = (amountBeforeVat * vatPerc) / 100;
        let totalAmount;

        if (selectedPOData?.costCenter5 === "excluded") {
            totalAmount = amountBeforeVat + vatAmount;
        } else {
            totalAmount = amountBeforeVat;
        }

        setRows(prevRows => {
            const newRows = [...prevRows];
            newRows[index].qty = newQty;
            newRows[index].baseQty = newQty * UOM || 0;
            newRows[index].amount = totalAmount;
            newRows[index].vatAmount = vatAmount;
            newRows[index].vatDes = vatDes;
            return newRows;
        });
    };
    const handleFreeQTChange = (index, value) => {
        const newQty = value || 0;
        const balQty = rows[index].balQty;
        const qty = rows[index].qty || 0;

        if (newQty < 0) {
            toast.warning('Quantity cannot be less than 0.');
            return;
        }

        setRows(prevRows => {
            const newRows = [...prevRows];
            newRows[index].freeQty = newQty;
            return newRows;
        });
    };
    const handleUnitPriceChange = (index, value) => {
        const unitPrice = value;
        const qty = rows[index].qty;
        const vatPerc = rows[index].vat;

        if (unitPrice < 0) {
            toast.warning('Quantity cannot be less than 0.');
            return;
        }

        const amountBeforeVat = unitPrice * qty;
        const vatAmount = (amountBeforeVat * vatPerc) / 100;
        let totalAmount;

        if (selectedPOData?.costCenter5 === "excluded") {
            totalAmount = amountBeforeVat + vatAmount;
        } else {
            totalAmount = amountBeforeVat;
        }

        setRows(prevRows => {
            const newRows = [...prevRows];
            newRows[index].baseAmount = unitPrice;
            newRows[index].amount = totalAmount;
            newRows[index].vatAmount = vatAmount;
            return newRows;
        });
    };
    const handleBatchNo = (index, value) => {
        const updatedRows = [...rows];
        updatedRows[index].batchNo = value;
        const updatedSelectedRows = rows.map((row, i) =>
            i === index ? { ...row, batchNo: value } : row
        );
        setRows(updatedSelectedRows);
        onRequisitionData(updatedSelectedRows);
    };
    const handleDateChange = (index, expDate) => {
        const updatedRows = [...rows];
        updatedRows[index].expDate = expDate;
        const updatedSelectedRows = rows.map((row, i) =>
            i === index ? { ...row, expDate: expDate } : row
        );
        setRows(updatedSelectedRows);
        onRequisitionData(updatedSelectedRows);
    };
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    };
    const netAmount = rows.reduce((sum, row) => sum + (parseFloat(row?.amount) || 0), 0)
    const totalVat = rows.reduce((sum, row) => sum + (parseFloat(row?.vatAmount) || 0), 0)
    const calculatedTotal = rows.reduce((sum, row) => sum + (parseFloat(row?.amount - row?.vatAmount) || 0), 0)
    return (
        <div>
            <div className='table-container p-1  p-2 mt-3 mb-3' style={{ overflowX: 'auto', height: "auto" }}>
                <table>
                    <thead className='dynoTable'>
                        <tr>
                            <th>Sr no</th>
                            <th>Item No</th>
                            <th>Description</th>
                            <th>Item Specs</th>
                            <th>Qty</th>
                            <th>Packing UOM</th>
                            <th>Inventory Qty</th>
                            <th>Bal Qty</th>
                            <th>Free Qty</th>
                            <th>Unit Price</th>
                            <th>Discount</th>
                            <th>VAT Desc</th>
                            <th>VAT %</th>
                            <th>VAT Amount</th>
                            <th>Amount</th>
                            <th>Batch No</th>
                            <th>Exp Date</th>
                        </tr>
                    </thead>
                    {grnData?.eye === true ?
                        <tbody>
                            {grnData?.grnDetails?.map((row, index) => (
                                <tr key={index}>
                                    <td className='m-0 p-0'><input className='p-2' value={index + 1} disabled style={{ width: "70px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' disabled value={row.itemCode} style={{ width: "100px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' disabled value={row.itemDescription} style={{ width: "130px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' disabled value={row.specification} style={{ width: "120px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' disabled style={{ width: "70px" }} value={row.qty} /></td>
                                    <td className='m-0 p-0'><input className='p-2' disabled value={row.uom} style={{ width: "130px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' disabled value={row.convToInvUOM * row.qty || 0} style={{ width: "130px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' disabled value={row.balQty || 0} style={{ width: "80px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' disabled value={row.extraQty} style={{ width: "100px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' disabled value={row.unitPrice || 0} style={{ width: "120px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' value={row.discount || 0} disabled style={{ width: "100px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' value={row.vatDesc} disabled style={{ width: "100px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' value={row.vatPerc + "%"} disabled style={{ width: "80px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' value={row.vatAmount || 0} disabled style={{ width: "120px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' disabled value={row.amount || 0} style={{ width: "100px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' disabled value={row.batchNo || 0} style={{ width: "100px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' value={moment(row?.expDate).format('DD-MMM-YYYY')}
                                        disabled style={{ width: "130px" }} /></td>
                                </tr>
                            ))}
                        </tbody> :
                        <tbody>
                            {rows?.map((row, index) => (
                                <tr key={index}>
                                    <td className='m-0 p-0'><input className='p-2' type="text" value={index + 1} disabled style={{ width: "70px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' disabled value={row.ItemNo} style={{ width: "100px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' disabled value={row.itemDescription} style={{ width: "130px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' disabled value={row.specification} style={{ width: "120px" }} /></td>
                                    <td className='m-0 p-0'>
                                        {grnData?.eye === true ?
                                            <input
                                                className='p-2'
                                                type="number" onWheel={(e) => e.target.blur()}
                                                disabled style={{ width: "70px" }}
                                                value={row.qty}
                                            />
                                            :
                                            <input
                                                className='p-2' onWheel={(e) => e.target.blur()}
                                                type="number" style={{ width: "70px" }}
                                                value={row.qty}
                                                onKeyDown={preventNegativeSign}
                                                max={row.balQty}
                                                onChange={(e) => handleQtyChange(index, e.target.value)}
                                            />
                                        }
                                    </td>
                                    <td className='m-0 p-0'><input className='p-2' disabled value={row.uom} style={{ width: "130px" }} /></td>
                                    {grnData?.eye === true ?
                                        <td className='m-0 p-0'><input className='p-2' disabled value={row.convValue * row.qty || 0} style={{ width: "130px" }} /></td> :
                                        <td className='m-0 p-0'><input className='p-2' disabled value={row.baseQty} style={{ width: "130px" }} /></td>
                                    }
                                    <td className='m-0 p-0'><input className='p-2' disabled value={row.balQty || 0} style={{ width: "80px" }} /></td>
                                    <td className='m-0 p-0'> {grnData?.eye === true ?
                                        <input
                                            className='p-2'
                                            type="number" onWheel={(e) => e.target.blur()}
                                            disabled style={{ width: "100px" }}
                                            value={row.freeQty}
                                        />
                                        :
                                        <input
                                            className='p-2' onWheel={(e) => e.target.blur()}
                                            type="number" style={{ width: "100px" }}
                                            value={row.freeQty}
                                            onKeyDown={preventNegativeSign}
                                            max={row.freeQty}
                                            onChange={(e) => handleFreeQTChange(index, e.target.value)}
                                        />
                                    }</td>
                                    <td className='m-0 p-0'> {grnData?.eye === true ?
                                        <input
                                            className='p-2'
                                            type="number"
                                            disabled style={{ width: "120px" }}
                                            value={row.baseAmount}
                                        />
                                        :
                                        <input
                                            className='p-2' onWheel={(e) => e.target.blur()}
                                            type="number" style={{ width: "120px" }}
                                            value={row.baseAmount}
                                            onKeyDown={preventNegativeSign}
                                            onChange={(e) => handleUnitPriceChange(index, e.target.value)}
                                        />
                                    }</td>
                                    <td className='m-0 p-0'><input className='p-2' type="text" value={row.discount} disabled style={{ width: "100px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' type="text" value={row.vatDes} disabled style={{ width: "100px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' type="text" value={row.vat + "%" || 0 + "%"} disabled style={{ width: "80px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' type="text" value={Number(row?.vatAmount).toFixed(currencyPrecision || 0)} disabled style={{ width: "120px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-2' disabled value={Number(row?.amount).toFixed(currencyPrecision || 0)} style={{ width: "100px" }} /></td>
                                    <td className='m-0 p-0'> {grnData?.eye === true ?
                                        <input
                                            className='p-2'
                                            type="number"
                                            disabled style={{ width: "120px" }}
                                            value={row.batchNo}
                                        />
                                        :
                                        <input
                                            className='p-2' onWheel={(e) => e.target.blur()}
                                            type="number" style={{ width: "120px" }}
                                            value={row.batchNo}
                                            onKeyDown={preventNegativeSign}
                                            onChange={(e) => handleBatchNo(index, e.target.value)}
                                        />
                                    }</td>
                                    <td className='m-0 p-0'>
                                        {grnData?.eye === true ?
                                            <input className='p-2' type='datetime' value={moment(row?.expDate).format('DD-MMM-YYYY')} disabled style={{ width: "130px" }} /> :
                                            <input className='p-2' type='date' value={row?.expDate ? row.expDate.split('T')[0] : ''}
                                                onChange={(e) => handleDateChange(index, e.target.value)} style={{ width: "130px" }} />
                                        }
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    }
                </table>
            </div>

            <div className='mt-3 p-1'>
                <div className='d-flex justify-content-between boxs p-2 mt-5 '>
                    <div className='d-flex gap-2'>
                        <div className="totalhead center">Total Amount</div>
                        <div className='field'>{calculatedTotal.toFixed(currencyPrecision || 0) || "---"}</div>
                    </div>
                    <div className='d-flex gap-2'>
                        <div className="totalhead center">Total Vat</div>
                        <div className='field'>{totalVat.toFixed(currencyPrecision || 0) || "---"}</div>
                    </div>
                    <div className='d-flex gap-2'>
                        <div className="totalhead center">Net Amount</div>
                        <div className='field'>{netAmount.toFixed(currencyPrecision || 0) || "---"}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ItemGridGRN;